import {
  type ResultOf,
  type VariablesOf,
} from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { usePathParams } from '~/apps/ninesegsAnalyzer/routes/paths'
import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

import { pathKey } from '../utils'

const document = graphql(`
  mutation SegmentDefinitionsPage_UpdateBrandGroup(
    $brandGroupId: Int!
    $segment_definitions: [SegmentdefinitionInput!]!
  ) {
    updateBrandGroup(
      brandGroupId: $brandGroupId
      input: { segment_definitions: $segment_definitions }
    ) {
      id
    }
  }
`)
type Data = ResultOf<typeof document>
type Variables = VariablesOf<typeof document>

export const useUpdateBrandGroupMutation = (
  options: Omit<
    UseMutationOptions<
      Data,
      unknown,
      Variables['segment_definitions'],
      unknown
    >,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()
  const { brandGroupId } = usePathParams(pathKey)

  return useMutation({
    mutationFn: (segment_definitions) =>
      graphQLRequest({
        document,
        variables: { brandGroupId: Number(brandGroupId), segment_definitions },
      }),
    ...options,
  })
}
